/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Ramda from 'ramda';

const { concat, gt, lt, ...R } = Ramda;

export default {
  ...R,
};
